import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import quoteReducer from './slices/quoteSlice';
import cargoReducer from './slices/cargoSlice';
import policyReducer from './slices/policySlice';

export default configureStore({
    reducer: {
        auth: authReducer,
        quotes: quoteReducer,
        cargo: cargoReducer,
        policies: policyReducer,
    },
});